import { combineReducers } from "@reduxjs/toolkit";
import { History } from "history";

import { adminReducer } from "./admin/index";
import { appCommonReducer } from "./appCommon/slice";
import { authReducer } from "./auth/slice";
import { communicationCombinedReducer } from "./communication/index";
import { enumsReducer } from "./enums/slice";
import { filesReducer } from "./files/slice";
import { managementReducer } from "./management";
import { operationsReducer } from "./operation/operationsSlice";
import { partiesReducer } from "./parties/slice";
import { profileReducer } from "./profile/slice";
import { repairReducer } from "./repair/index";
import { tenantProfileReducer } from "./tenantProfile/slice";
import { tenantToTenantReducer } from "./tenantToTenant/tenantToTenantSlice";
import { tenantsReducer } from "./tenants/slice";

const createRootReducer = (history: History) =>
  combineReducers({
    app: appCommonReducer,
    auth: authReducer,
    profile: profileReducer,
    tenantProfile: tenantProfileReducer,
    tenants: tenantsReducer,
    enums: enumsReducer,
    communication: communicationCombinedReducer,
    management: managementReducer,
    repair: repairReducer,
    parties: partiesReducer,
    tenantToTenant: tenantToTenantReducer,
    operations: operationsReducer,
    files: filesReducer,

    admin: adminReducer,
  });

export default createRootReducer;
